import React from "react"
import SummaryTable from "../../components/summary/summary-table"
import SummaryButtons from "../../components/summary/summary-buttons"
import { connect } from "react-redux"
import {
  getDeviceSummaryDetails,
  getPlanSummaryDetails,
  getExtrasSummaryDetails,
  getTotalCosts,
  hasSwappableBenefits
} from "../../redux/selectors/basket-selectors"
import { firstPage } from "../../redux/actions/journey-actions"
import "./summary-page.scss"

const SummaryPage = ({
  deviceSummary,
  planSummary,
  extrasSummary,
  totalCosts,
  gotoFirstPage,
  excludeVAT,
  vatDivider,
  selectedBenefits,
  numberOfSwappableBenefits
}) => {
  return (
    <div className="summary-page--container">
      <div className="summary-page">
        <h3>Your Shopping Basket</h3>
        <SummaryTable
          deviceSummary={deviceSummary}
          planSummary={planSummary}
          extrasSummary={extrasSummary}
          totalCosts={totalCosts}
          excludeVAT={excludeVAT}
          vatDivider={vatDivider}
        />
        <SummaryButtons
          onEmptyBasket={gotoFirstPage}
          numberOfSwappableBenefits={numberOfSwappableBenefits}
          selectedBenefits={selectedBenefits}
        />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  deviceSummary: getDeviceSummaryDetails(state),
  planSummary: getPlanSummaryDetails(state),
  extrasSummary: getExtrasSummaryDetails(state),
  selectedBenefits: state.basket.benefits,
  totalCosts: getTotalCosts(state),
  excludeVAT: state.plans.options.excludeVAT,
  vatDivider: state.plans.options.vatDivider,
  hasSwappableBenefits: hasSwappableBenefits(state),
  numberOfSwappableBenefits:
    !state.basket.builtPlan &&
    state.plans.byID[state.basket.planID].swappableBenefits &&
    state.plans.byID[state.basket.planID].swappableBenefits.amount
})

const mapDispatchToProps = dispatch => ({
  gotoFirstPage: () => dispatch(firstPage())
})

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage)
